import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "ECC Order Claim")
  ])
], -1)
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-3 fv-row" }
const _hoisted_7 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "col-md-1 fv-row" }
const _hoisted_10 = { class: "d-flex flex-column mb-1 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label " }, null, -1)
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Order ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "SKU ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Date Claimed")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_EstoreTabNavigator = _resolveComponent("EstoreTabNavigator")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_EstoreTabNavigator, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
        ]),
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: "Order ID here",
                    name: "order_id",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.order_id = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.order_id]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-primary er fs-6 px-8 py-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.claimECCOrder();})
                  }, " Claim ")
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("table", _hoisted_14, [
              _hoisted_15,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, "   " + _toDisplayString(item.id), 1),
                    _createVNode("td", null, _toDisplayString(item.order_id), 1),
                    _createVNode("td", null, _toDisplayString(item.sku_id), 1),
                    _createVNode("td", null, _toDisplayString(item.qty), 1),
                    _createVNode("td", null, _toDisplayString(_ctx.formatDate(item.claim_date)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading ]
    ])
  ], 64))
}